import React from 'react';

const LoadingSpinner: React.FC = () => {
  return (
    <div className="flex justify-center items-center h-full">
      <div className="relative w-10 h-10">
        <div className="animate-ping absolute inset-0 bg-emerald-400 opacity-75 rounded-full"></div>
        <div className="relative w-10 h-10 bg-emerald-500 rounded-full animate-pulse"></div>
      </div>
      <span className="ml-4 text-slate-300">Loading messages...</span>
    </div>
  );
};

export default LoadingSpinner;
